<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0" v-if="isapp">
      <h2 class="qrs-header-xl mt--0 mb--0">Medicines sick day guidance</h2>
    </pageHeader>

    <h1 v-if="!isapp" class="qrs-header-xl">Medicines sick day guidance</h1>
    <p>
      If you are taking any of the groups of medicines listed below, please
      enter their names so that you can save and print this information on your
      Sick Day Guidance card.
    </p>

    <div v-for="(item, index) in jsonData" v-bind:key="index">
      <accordion>
        <template v-slot:title>
          <p v-if="item.id != 'Other medicines'" class="m-0 firstLetter">
            {{ item.category }}
          </p>
          <p v-else class="m-0">
            <strong>{{ item.category }}</strong>
          </p>
        </template>
        <template v-slot:content>
          <div
            v-if="item.id != 'Other medicines'"
            class="mt--16"
            @click.stop.prevent="handleClick"
          >
            <a class="qrs-link" :href="item.moreInfo" target="_blank">
              <i
                aria-label="chevron-right"
                aria-hidden="true"
                class="fa fa-external-link-alt"
              ></i>
              More information
            </a>
          </div>

          <div class="govuk-form-group">
            <fieldset class="govuk-fieldset govuk-grid-column-one-half">
              <div v-for="innerItem in item.data" v-bind:key="innerItem.id">
                <div class="mt--24 mb--16">
                  <label class="govuk-label" :for="innerItem.title">{{
                    innerItem.title
                  }}</label>
                  <input
                    v-model="innerItem.value"
                    type="text"
                    :id="innerItem.id"
                    class="govuk-input"
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </template>
      </accordion>
    </div>

    <div class="mt--24">
      <button
        v-if="!isapp"
        name="Save and share"
        aria-label="Save all data inputs and continue to share"
        class="govuk-button mr--16"
        @click="saveForm()"
      >
        Save and share
        <span class="screen-reader-text"
          >Save all data inputs and continue to share</span
        >
      </button>
      <button
        v-if="isapp"
        name="Save and share"
        aria-label="Save all data inputs and continue to share"
        class="govuk-button"
        @click="saveForm()"
      >
        Save and share
        <span class="screen-reader-text"
          >Save all data inputs and continue to share</span
        >
      </button>
      <button
        name="Cancel"
        aria-label="return to the previous page"
        class="govuk-button govuk-button--neutral"
        @click="cancelClicked()"
      >
        Cancel
        <span class="screen-reader-text">return to the previous page</span>
      </button>
    </div>
  </section>
</template>

<script>
import accordion from "../controls/accordion.vue";
export default {
  components: { accordion },
  name: "guidanceForm",

  data() {
    return {
      isapp: this.$parent.isapp,
      jsonData: this.$parent.jsonData,
      answeredItems: this.$parent.answeredItems,
      active: false,
      valuePresent: null,
    };
  },

  methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        console.log(dataId, "DATAID");
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
          console.log("in web open");
        } else {
          let data = { title: "", nodeid: dataId, href: url, target: target };
          console.log("in app open");
          window.Native("dataCallback", data);
        }
      }
    },
    cancelClicked() {
      for (var i in this.jsonData) {
        this.jsonData[i].data.forEach(function (item) {
          item.value = "";
        });
      }
      this.answeredItems = [];
      console.log(this.answeredItems);
      this.$parent.goTo(this.$Intro);
    },
    saveForm() {
      let string = JSON.stringify(this.jsonData);
      let data = JSON.parse(string);
      this.answeredItems.push(data);
      this.$parent.goTo(this.$FormSummary);

      let answerItems = this.answeredItems;

      for (var i in answerItems[0]) {
        let item = answerItems[0][i];
        console.log(item);
        console.log(item.total);

        for (var innerItem in item.data) {
          let input = item.data[innerItem];
          console.log(input);
          if (input.value.length === 0) {
            item.total++;
          }
          if (item.total === 3) {
            item.response = "No medicines identified";
          }
        }
      }
    },
  },
};
</script>